import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Icon, { IconNames } from 'components/icons/icons'
import { FavoriteWorkout } from 'lib/favoriteWorkouts'
import { getWorkoutDuration } from 'lib/stats'
import { toRoundedFullTime } from 'lib/utilities'
import { INRWorkoutTemplate } from 'interfaces/workout'
import WorkoutCard from './workout-card'
import './workout.scss'

interface Props {
  favorite: FavoriteWorkout
  template?: INRWorkoutTemplate
  customClick: () => void
}

const FavoriteCard = ({ favorite, template, customClick }: Props) => {
  if (favorite.kind === 'template') {
    return template ? <WorkoutCard customClick={customClick} isFavorite template={template} /> : null
  }

  const workoutTime = toRoundedFullTime(getWorkoutDuration(favorite.workoutSession))

  return (
    <div className="workoutCard" onClick={customClick}>
      <div className="workoutCard__container">
        <div
          className="workoutCard__header"
          style={{ backgroundImage: `url('${favorite.favoriteImage}')` }}
        />
        <div className="workoutCard__content workoutCard__content--favorite">
          <div className="workoutCard__content__title">{favorite.workoutSession.name}</div>
          <div className="workoutCard__content__duration">
            <Icon name={IconNames.CLOCK} />
            <h5 className="light">{workoutTime}</h5>
          </div>
          <FontAwesomeIcon
            aria-label="Favorite"
            className="workoutCard__favorite"
            icon={faStar}
            style={{ height: '1.5rem', width: '1.5rem' }}
          />
        </div>
      </div>
    </div>
  )
}

export default FavoriteCard
